import { Component, Input, OnInit } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { Order } from '../../../payments/payment/interfaces/payment-summary.interface';
import { AmountPipe } from '../../../payments/payment/pipes/amount.pipe';
import { CommonModule } from '@angular/common';
import { TimestampPipe } from '../../../payments/payment/pipes/timestamp.pipe';
import { OrderDetailTableComponent } from '../order-detail-table/order-detail-table.component';

@Component({
  standalone: true,
  imports: [
    MatTableModule,
    AmountPipe,
    CommonModule,
    TimestampPipe,
    OrderDetailTableComponent
  ],
  selector: 'equine-ui-nx-order-table',
  templateUrl: './order-table.component.html',
  styleUrls: ['./order-table.component.scss']
})
export class OrderTableComponent implements OnInit {

  @Input() order!: Order;

  displayedColumns = ['description', 'quantity', 'unitAmount', 'total']

  constructor() { }

  ngOnInit() {
  }

}
